/** Textos da interface em pt-BR (estruturados com i18next desde o início). */
const ptBR = {
  app: { name: 'High Command', tagline: 'Estratégia global em turnos longos' },
  nav: {
    map: 'Mapa',
    territories: 'Territórios',
    orders: 'Ordens',
    fleet: 'Frota',
    market: 'Bolsa',
    research: 'Pesquisa',
    logistics: 'Logística',
    intel: 'Intel',
    diplomacy: 'Diplomacia',
    news: 'Notícias',
    score: 'Placar',
    government: 'Governo',
    simulator: 'Simulador',
    lobby: 'Lobby',
    admin: 'Admin',
    account: 'Conta',
    logout: 'Sair',
  },
  header: {
    dtg: 'DTG',
    treasury: 'Tesouro',
    specials: 'Ord ★',
    turn: 'Virada T{{turn}} · {{time}}',
    resolving: 'Virada em andamento',
    secret: 'SECRETO // {{gov}} // {{match}}',
  },
  auth: {
    login: 'Entrar',
    register: 'Criar conta',
    phone: 'Celular',
    phoneHint: 'Com DDD. Enviamos um código por SMS.',
    username: 'Usuário',
    loginField: 'Usuário ou celular',
    password: 'Senha',
    newPassword: 'Nova senha',
    forgot: 'Esqueci a senha',
    noAccount: 'Não tem conta?',
    hasAccount: 'Já tem conta?',
    verifyTitle: 'Confirmação de celular',
    verifyOk: 'Celular confirmado. Você já pode entrar em partidas.',
    verifyPending: 'Confirme seu celular para entrar em partidas.',
    verifyAction: 'Confirmar celular',
    codeSent: 'Enviamos um código por SMS para {{phone}}.',
    code: 'Código',
    codeHint: '6 dígitos, válido por 15 minutos',
    confirm: 'Confirmar',
    sendCode: 'Enviar código',
    resend: 'Reenviar código',
    resendIn: 'Reenviar em {{s}} s',
    changePhone: 'Trocar número',
    forgotTitle: 'Recuperar senha',
    forgotSent: 'Se o celular tiver conta, enviamos um código válido por 15 minutos.',
    resetOk: 'Senha alterada. Entre de novo.',
    send: 'Enviar',
    save: 'Salvar',
  },
  lobby: {
    title: 'Partidas',
    create: 'Nova partida',
    join: 'Entrar',
    open: 'Abrir',
    start: 'Iniciar partida',
    players: 'Governos',
    empty: 'Nenhuma partida aberta. Crie a primeira.',
    status: { LOBBY: 'Aguardando', RUNNING: 'Em andamento', PAUSED: 'Pausada', FINISHED: 'Encerrada' },
    bot: 'IA',
  },
  orders: {
    title: 'Ordem frag · T{{turn}}',
    draft: 'Não salva',
    saved: 'Ordem salva',
    save: 'Salvar ordem',
    cancel: 'Cancelar',
    remove: 'Remover ordem',
    chooseType: 'Escolha o tipo de ordem.',
    inRange_one: '{{count}} destino ao alcance',
    inRange_other: '{{count}} destinos ao alcance',
    noTargets: 'Nenhum destino ao alcance com as unidades escolhidas.',
    cargo: 'Carga',
    cargoLine: '{{troops}}/{{maxTroops}} soldados · {{vehicles}}/{{maxVehicles}} veículos',
    cargoHint:
      'As tropas e veículos marcados embarcam nos navios de desembarque. No turno seguinte, selecione a zona marítima e dê Marcha para a costa só com as tropas (−30% de ATQ contra inimigos ou neutros).',
    landHint:
      'Tropas embarcadas: dê Marcha para a costa só com as tropas para desembarcar (−30% de ATQ contra inimigos ou neutros). Os navios ficam na zona.',
    unsavedSwitch: 'Esta ordem tem alterações não salvas.',
    discardAndOpen: 'Descartar e abrir {{place}}',
    keepEditing: 'Continuar editando',
    special: 'Especial ★',
    origin: 'Origem',
    objective: 'Objetivo',
    forces: 'Forças empenhadas',
    correlation: 'Correlação de forças',
    own: 'Próprio',
    opponent: 'Oponente',
    losses: 'Perdas estimadas',
    selectTarget: 'Clique no mapa para escolher o destino.',
    none: 'Selecione um território ou zona com unidades suas.',
  },
  common: {
    loading: 'Carregando…',
    error: 'Erro',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Fechar',
    yes: 'Sim',
    no: 'Não',
  },
};

export default ptBR;
